export interface AssignedToI18n {
    allParticipants: string;
    oneParticipant: string;
    manyParticipants: (count: number) => string;
    groups: (count: number) => string;
    oneGroup: (oneGroup: string) => string;
    oneParticipantAndOneGroup: (groupName: string) => string;
    oneParticipantAndManyGroups: (groupCount: number) => string;
    manyParticipantsAndOneGroup: (participantCount: number, groupName: string) => string;
    manyParticipantsAndManyGroups: (participantCount: number, groupCount: number) => string;
}

/**
 * Returns display text describing who is assigned based on participant/group counts.
 */
export function getAssignedToText(participantCount: number, groupCount: number, groupName: string, i18n: AssignedToI18n): string {
    if (participantCount === 0 && groupCount === 0) {
        return i18n.allParticipants;
    }
    if (participantCount === 1 && groupCount === 0) {
        return i18n.oneParticipant;
    }
    if (participantCount > 1 && groupCount === 0) {
        return i18n.manyParticipants(participantCount);
    }
    if (participantCount === 0 && groupCount === 1) {
        return i18n.oneGroup(groupName);
    }
    if (participantCount === 0 && groupCount > 1) {
        return i18n.groups(groupCount);
    }
    if (participantCount === 1 && groupCount === 1) {
        return i18n.oneParticipantAndOneGroup(groupName);
    }
    if (participantCount === 1 && groupCount > 1) {
        return i18n.oneParticipantAndManyGroups(groupCount);
    }
    if (participantCount > 1 && groupCount === 1) {
        return i18n.manyParticipantsAndOneGroup(participantCount, groupName);
    }
    if (participantCount > 1 && groupCount > 1) {
        return i18n.manyParticipantsAndManyGroups(participantCount, groupCount);
    }

    return '';
}
